<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">

  <form class="popup-container patient-setup-popup form-container" #f="ngForm" (ngSubmit)="onSubmit(f)">
    <div class="popup-content">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>
      <!-- popup body - content view -->
      <div class="popup-body">
        <div class="popup-setup-view" *ngIf="popup?.PopupAction == 'EDIT' || popup?.PopupAction == 'NEW'">
          <div class="setup-view-title">
            <div class="setup-title row align-center">
              <div class="title row">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7116 21.2142C20.0518 19.1569 18.7558 17.3623 17.0106 16.0891C15.2651 14.8159 13.1605 14.1299 11.0001 14.1299C8.83971 14.1299 6.73511 14.8159 4.98974 16.0891C3.24439 17.3623 1.94842 19.1569 1.2887 21.2142H20.7116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11 14.1428C14.6729 14.1428 17.6504 11.1653 17.6504 7.49241C17.6504 3.81951 14.6729 0.842041 11 0.842041C7.32709 0.842041 4.34961 3.81951 4.34961 7.49241C4.34961 11.1653 7.32709 14.1428 11 14.1428Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M13.1717 10.0657C13.1717 10.0657 12.6199 11.1514 11.0002 11.1514C9.38042 11.1514 8.82861 10.0657 8.82861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.5299 6.22623C17.515 6.22632 17.5002 6.22637 17.4855 6.22637C15.5523 6.22637 13.8168 5.38064 12.6286 4.03902C11.4404 5.38067 9.70486 6.22642 7.77177 6.22642C6.64923 6.22642 5.5933 5.94122 4.67249 5.43934C5.53762 2.77119 8.04347 0.842041 10.9999 0.842041C14.2398 0.842041 16.9386 3.15891 17.5299 6.22623Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h3>Staff Member</h3>
              </div>
              <div class="row gap-10 align-center">
                <span *ngIf="staffMemberError && submitted" class="error-message">*</span>
                <div class="form-group" [ngClass]="{'invalid-border': staffMemberError && submitted}">
                  <app-custom-dropdown [options]="staffList"
                                       [placeholder]="'Select an option'"
                                       [(ngModel)]="patient.ParentMemberGuid"
                                       [optionsText]="'FullName'"
                                       [optionsValue]="'Guid'"
                                       tabindex="1"
                                       [ngModelOptions]="{standalone: true}">
                  </app-custom-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-setup-view" *ngIf="popup?.PopupAction == 'EDIT' || popup?.PopupAction == 'VIEW'">
          <div class="title">
            <h2>{{patientDetails.Title}} {{patientDetails.FullName}}</h2>
          </div>
          <div class="content-group">
            <label>Patient ID / Passport Number:</label>
            <p>{{patientDetails.IDNumber}}</p>
          </div>
          <div class="patient-details">
            <div class="details-column">
              <div class="content-group">
                <label>Title:</label>
                <p>{{patientDetails.Title}}</p>
              </div>
              <div class="content-group">
                <label>Gender:</label>
                <p>{{patientDetails.GenderType}}</p>
              </div>
            </div>
            <div class="details-column">
              <div class="content-group">
                <label>Patient Name:</label>
                <p>{{patientDetails.FullName}}</p>
              </div>
              <!--<div class="content-group">
                <label>Email Address:</label>
                <p>{{patientDetails.Email}}</p>
              </div>-->
            </div>
            <div class="details-column">
              <div class="content-group">
                <label>Patient Status:</label>
                <p><strong>{{patientDetails.Status}}</strong></p>
              </div>
              <div class="content-group">
                <label>Cellphone:</label>
                <p>{{patientDetails.Cellphone}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- popup body - setup form -->
        <div class="popup-setup-form" *ngIf="popup?.PopupAction == 'VIEW'">
          <!--Setup Edit html-->
          <div class="title">
            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.9285 2.35718H15.2857C15.7024 2.35718 16.1022 2.52274 16.3968 2.81743C16.6915 3.11214 16.8571 3.51183 16.8571 3.92861V19.6429C16.8571 20.0596 16.6915 20.4594 16.3968 20.7541C16.1022 21.0487 15.7024 21.2143 15.2857 21.2143H2.71425C2.29748 21.2143 1.89778 21.0487 1.60308 20.7541C1.30839 20.4594 1.14282 20.0596 1.14282 19.6429V3.92861C1.14282 3.51183 1.30839 3.11214 1.60308 2.81743C1.89778 2.52274 2.29748 2.35718 2.71425 2.35718H5.07139" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11.357 0.785645H6.64272C5.77485 0.785645 5.07129 1.4892 5.07129 2.35707V3.14279C5.07129 4.01066 5.77485 4.71422 6.64272 4.71422H11.357C12.2249 4.71422 12.9284 4.01066 12.9284 3.14279V2.35707C12.9284 1.4892 12.2249 0.785645 11.357 0.785645Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.9042 8.18701C7.53155 8.18701 7.22946 8.4891 7.22946 8.86177V10.7595H5.33172C4.95907 10.7595 4.65698 11.0616 4.65698 11.4343V13.6272C4.65698 13.9998 4.95907 14.3019 5.33172 14.3019H7.22946V16.1996C7.22946 16.5722 7.53155 16.8744 7.9042 16.8744H10.0971C10.4698 16.8744 10.7719 16.5722 10.7719 16.1996V14.3019H12.6696C13.0423 14.3019 13.3443 13.9999 13.3443 13.6272V11.4343C13.3443 11.0616 13.0423 10.7595 12.6696 10.7595H10.7719V8.86177C10.7719 8.4891 10.4698 8.18701 10.0971 8.18701H7.9042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Patient Notes</h3>
          </div>
          <div class="form-group">
            <textarea style="padding: 5px; height: 48px;" type="text" class="input-control" placeholder="Enter Patient Notes" [(ngModel)]="patient.Notes" tabindex="2" [ngModelOptions]="{standalone: true}"> </textarea>

            <!--<div class="custom-input-placeholder">
        <span class="custom-placeholder" *ngIf="!patient.Notes">Enter Patient Notes</span>
      </div>-->
          </div>
          <!---->
        </div>


        <div class="popup-setup-form" style="gap: 40px;" *ngIf="popup?.PopupAction == 'NEW' || popup?.PopupAction == 'EDIT'">
          <!--Setup Edit html-->
          <div class="title" *ngIf="popup?.PopupAction == 'EDIT' || popup?.PopupAction == 'VIEW'">
            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.9285 2.35718H15.2857C15.7024 2.35718 16.1022 2.52274 16.3968 2.81743C16.6915 3.11214 16.8571 3.51183 16.8571 3.92861V19.6429C16.8571 20.0596 16.6915 20.4594 16.3968 20.7541C16.1022 21.0487 15.7024 21.2143 15.2857 21.2143H2.71425C2.29748 21.2143 1.89778 21.0487 1.60308 20.7541C1.30839 20.4594 1.14282 20.0596 1.14282 19.6429V3.92861C1.14282 3.51183 1.30839 3.11214 1.60308 2.81743C1.89778 2.52274 2.29748 2.35718 2.71425 2.35718H5.07139" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11.357 0.785645H6.64272C5.77485 0.785645 5.07129 1.4892 5.07129 2.35707V3.14279C5.07129 4.01066 5.77485 4.71422 6.64272 4.71422H11.357C12.2249 4.71422 12.9284 4.01066 12.9284 3.14279V2.35707C12.9284 1.4892 12.2249 0.785645 11.357 0.785645Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.9042 8.18701C7.53155 8.18701 7.22946 8.4891 7.22946 8.86177V10.7595H5.33172C4.95907 10.7595 4.65698 11.0616 4.65698 11.4343V13.6272C4.65698 13.9998 4.95907 14.3019 5.33172 14.3019H7.22946V16.1996C7.22946 16.5722 7.53155 16.8744 7.9042 16.8744H10.0971C10.4698 16.8744 10.7719 16.5722 10.7719 16.1996V14.3019H12.6696C13.0423 14.3019 13.3443 13.9999 13.3443 13.6272V11.4343C13.3443 11.0616 13.0423 10.7595 12.6696 10.7595H10.7719V8.86177C10.7719 8.4891 10.4698 8.18701 10.0971 8.18701H7.9042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Patient Notes</h3>
          </div>
          <div class="form-group" *ngIf="popup?.PopupAction == 'EDIT' || popup?.PopupAction == 'VIEW'">
            <textarea style="padding: 5px; height: 48px;" type="text" class="input-control" placeholder="Enter Patient Notes" [(ngModel)]="patient.Notes"tabindex="3" [ngModelOptions]="{standalone: true}"> </textarea>
          </div>
          <div class="title" *ngIf="popup?.PopupAction == 'EDIT'">
            <h3>Update Patient Details</h3>
          </div>
          <!---->
          <!--Setup New html-->
          <div class="title" *ngIf="popup?.PopupAction == 'NEW'">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.14296 7.85721C9.1154 7.85721 10.7144 6.25823 10.7144 4.28578C10.7144 2.31334 9.1154 0.714355 7.14296 0.714355C5.17052 0.714355 3.57153 2.31334 3.57153 4.28578C3.57153 6.25823 5.17052 7.85721 7.14296 7.85721Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.14293 17.8573H0.714355V17.0828C0.725728 15.994 1.01289 14.9257 1.54903 13.9779C2.08517 13.0301 2.85278 12.2337 3.78017 11.663C4.70757 11.0923 5.76448 10.766 6.85218 10.7145C6.94916 10.7099 7.0461 10.7075 7.14293 10.7073C7.23976 10.7075 7.33671 10.7099 7.43368 10.7145C8.52138 10.766 9.5783 11.0923 10.5057 11.663C11.039 11.9912 11.5194 12.394 11.9334 12.8573" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19.2858 12.1428L13.5715 19.2857L10.7144 17.1428" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Patient Details</h3>
          </div>

          <div class="form-group">
            <span *ngIf="IDNumber.invalid && submitted" class="invalid-text">*</span>
            <label>Patient ID/Passport:</label>
            <input type="text" class="input-control" [(ngModel)]="patient.IDNumber" id="IDNumber" name="IDNumber" #IDNumber="ngModel" [ngClass]="{'invalid-border': IDNumber.invalid && submitted}" placeholder="Enter ID / Passport Number" required tabindex="4" />
          </div>

          <!---->
          <!--Setup Pateint detail fields html-->
          <div class="row gap-30">
            <div class="form-group row align-center gap-10">
              <label>Patient Status: <strong *ngIf="popup?.PopupAction != 'EDIT'">{{patient.Status || 'New'}}</strong></label>
              <app-custom-dropdown *ngIf="popup?.PopupAction == 'EDIT'"
                                   [options]="statusList"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="patient.Status"
                                   [optionsText]="'Description'"
                                   [optionsValue]="'Description'"
                                   [ngModelOptions]="{standalone: true}"
                                   tabindex="5">
              </app-custom-dropdown>
            </div>
            <div class="form-group row align-center gap-10">
              <label>Patient Type:</label>
              <app-custom-dropdown [options]="patientGroups"
                                   [placeholder]="'Select an option'"
                                   [(ngModel)]="patient.MemberType"
                                   [optionsText]="'Type'"
                                   [optionsValue]="'Type'"
                                   [ngModelOptions]="{standalone: true}"
                                   tabindex="6">
              </app-custom-dropdown>
            </div>
          </div>
          <div class="patient-details">
            <!--detail group-->
            <div class="details-column">
              <div class="form-group row align-center gap-10">
                <app-custom-dropdown [options]="titles"
                                     [placeholder]="'Title'"
                                     [(ngModel)]="patient.Title"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     [ngModelOptions]="{standalone: true}"
                                     tabindex="7">
                </app-custom-dropdown>
              </div>

              <div class="form-group row align-center gap-10">
                <app-custom-dropdown [options]="genders"
                                     [placeholder]="'Select a Gender'"
                                     [(ngModel)]="patient.Gender"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'ID'"
                                     [ngModelOptions]="{standalone: true}"
                                     tabindex="10">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="details-column">
              <div class="form-group">
                <span *ngIf="Name.invalid && submitted" class="invalid-text">*</span>
                <label>Patient Name:</label>
                <input type="text" class="input-control" [(ngModel)]="patient.Name" id="Name" name="Name" #Name="ngModel"  [ngClass]="{'invalid-border': Name.invalid && submitted}" placeholder="Enter Patient Name"  style="text-transform: uppercase;" tabindex="8" required />

              </div>
              <div class="form-group">
                <span *ngIf="Cellphone.invalid && submitted" class="invalid-text">*</span>
                <label>Cellphone:</label>
                <input type="tel" class="input-control" [(ngModel)]="patient.Cellphone" id="Cellphone" name="Cellphone" #Cellphone="ngModel" [ngClass]="{'invalid-border': Cellphone.invalid && submitted}" placeholder="Enter Patient Cellphone" required tabindex="12" />
              </div>
            </div>
            <div class="details-column">
              <div class="form-group">
                <span *ngIf="Surname.invalid && submitted" class="invalid-text">*</span>
                <label>Patient Surname:</label>
                <input type="text" class="input-control" [(ngModel)]="patient.Surname" id="Surname" name="Surname" #Surname="ngModel" [ngClass]="{'invalid-border': Surname.invalid && submitted}" placeholder="Enter Patient Surname" style="text-transform: uppercase;" tabindex="9" required />
              </div>
              <div class="form-group row align-center gap-10">
                <label>Send Confirmation:</label>
                <app-custom-dropdown [options]="confirmationMessageTypes"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="patient.ContactMethod"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     [ngModelOptions]="{standalone: true}"
                                     tabindex="13">
                </app-custom-dropdown>
              </div>
            </div>
          </div>
          <!---->
          <div>
            <hr />
          </div>

          <!---->
          <div class="column gap-20">
            <div class="title" *ngIf="popup?.PopupAction == 'NEW'">
              <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9285 2.35718H15.2857C15.7024 2.35718 16.1022 2.52274 16.3968 2.81743C16.6915 3.11214 16.8571 3.51183 16.8571 3.92861V19.6429C16.8571 20.0596 16.6915 20.4594 16.3968 20.7541C16.1022 21.0487 15.7024 21.2143 15.2857 21.2143H2.71425C2.29748 21.2143 1.89778 21.0487 1.60308 20.7541C1.30839 20.4594 1.14282 20.0596 1.14282 19.6429V3.92861C1.14282 3.51183 1.30839 3.11214 1.60308 2.81743C1.89778 2.52274 2.29748 2.35718 2.71425 2.35718H5.07139" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.357 0.785645H6.64272C5.77485 0.785645 5.07129 1.4892 5.07129 2.35707V3.14279C5.07129 4.01066 5.77485 4.71422 6.64272 4.71422H11.357C12.2249 4.71422 12.9284 4.01066 12.9284 3.14279V2.35707C12.9284 1.4892 12.2249 0.785645 11.357 0.785645Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.9042 8.18701C7.53155 8.18701 7.22946 8.4891 7.22946 8.86177V10.7595H5.33172C4.95907 10.7595 4.65698 11.0616 4.65698 11.4343V13.6272C4.65698 13.9998 4.95907 14.3019 5.33172 14.3019H7.22946V16.1996C7.22946 16.5722 7.53155 16.8744 7.9042 16.8744H10.0971C10.4698 16.8744 10.7719 16.5722 10.7719 16.1996V14.3019H12.6696C13.0423 14.3019 13.3443 13.9999 13.3443 13.6272V11.4343C13.3443 11.0616 13.0423 10.7595 12.6696 10.7595H10.7719V8.86177C10.7719 8.4891 10.4698 8.18701 10.0971 8.18701H7.9042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Patient Notes</h3>
            </div>
            <div class="form-group" *ngIf="popup?.PopupAction == 'NEW'">
              <textarea style="padding: 5px; height: 48px;" type="text" class="input-control" placeholder="Enter Patient Notes" [ngModelOptions]="{standalone: true}" [(ngModel)]="patient.Notes" tabindex="14" > </textarea>
            </div>
            <!--Setup Edit html-->
            <div class="title" *ngIf="popup?.PopupAction == 'Edit'">
              <h3>Additional Patient Notes</h3>
            </div>
            <div class="form-group" *ngIf="popup?.PopupAction == 'EDIT'">
              <textarea style="padding: 5px; height: 48px;" type="text" class="input-control" placeholder="Enter Patient Notes" [ngModelOptions]="{standalone: true}" [(ngModel)]="patient.AdditionalNotes" tabindex="16" > </textarea>
            </div>
          </div>

        </div>
        <div class="popup-buttons" *ngIf="popup?.PopupAction != 'VIEW'">
          <button type="submit" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
      <div class="appointment-history column" *ngIf="popup?.PopupAction == 'VIEW'">
        <div class="popup-header" *ngIf="activityHistory.length > 0" >
          <h1>Activity History</h1>
        </div>
        <div class="custom-table" *ngIf="activityHistory.length > 0" >
          <div class="details-row history-details" *ngFor="let activity of activityHistory">
            <div class="detail-group">
              <p><span>{{activity.ActionDate}}</span></p>
              <p>{{activity.Action}}</p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.AgentName}}</span></p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.ActionDetails}}</span></p>
              <p>Ear Institute {{activity.BranchName}}</p>
            </div>
            <div class="detail-group">
              <p><span>{{activity.ActionResult}}</span></p>
              <p style="font-style: italic">{{activity.ActionResult2}}</p>
            </div>
          </div>
        </div>
        <div class="popup-buttons" style=" padding: 0px 30px 30px;" *ngIf="popup?.PopupAction == 'VIEW'">
          <button *ngIf="activityHistory.length > 0" type="button" (click)="ButtonClick()" class="popup-btn">{{ popup?.Button?.ButtonText || 'Close' }}</button>
          <button type="button" *ngIf="popup?.AltButton?.Result" (click)="AltButtonClick()" class="popup-btn">{{ popup?.AltButton?.ButtonText }}</button>
        </div>
      </div>
    </div>
    </form>
</div>
